<template>
  <div class="container-fluid mt-4">
    <div id="profile" class="card card-body mt-4">
      <div v-if="profile" class="row justify-content-center align-items-center">
        <div class="col-sm-auto col-4">
          <soft-avatar
            :img="pic"
            alt="profile"
            size="xl"
            shadow="sm"
            border-radius="lg"
          />
        </div>
        <div class="col-sm-auto col-8 my-auto">
          <div class="h-100">
            <h5 class="mb-1 font-weight-bolder">{{ profile.name }}</h5>
            <p class="mb-0 font-weight-bold text-sm">{{ profile.email }}</p>
          </div>
        </div>

        <!--div class="col-sm-auto ms-sm-auto mt-sm-0 mt-3 d-flex">
          <label class="form-check-label mb-0 me-2">
            <small id="profileVisibility">Switch to invisible</small>
          </label>
          <soft-switch id="profile" name="profileVisibility" checked />
        </div-->
      </div>
    </div>

    <div class="row">

      <div class="col-12">
        <div id="password" class="card mt-4">
          <div class="card-header">
            <h5>Passwort ändern</h5>
          </div>

          <div class="card-body pt-0">
            <div class="row mb-3">
              <label class="form-label">Neues Passwort</label>
              <soft-model-input
                id="newPassword"
                v-model="passChange.password"
                type="password"
                placeholder="Neues Passwort"
              />
              <validation-error :errors="apiValidationErrors.password" />
            </div>

            <div class="row mb-3">
              <label class="form-label">Neues Passwort bestätigen</label>
              <soft-model-input
                id="confirmPassword"
                v-model="passChange.password_confirmation"
                type="password"
                placeholder="Passwort bestätigen"
              />
            </div>

            <soft-button
              color="dark"
              variant="gradient"
              class="float-end mt-6 mb-0"
              size="sm"
              :is-disabled="loading ? true : false"
              @click="handlePassChange"
              ><span
                v-if="loading"
                class="spinner-border spinner-border-sm"
              ></span>
              <span v-else>Passwort ändern</span></soft-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";
import SoftAvatar from "@/components/SoftAvatar.vue";
import SoftModelInput from "@/components/SoftModelInput.vue";
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "/src/mixins/form-mixin.js";
import img from "/src/assets/img/bruce-mars.jpg";
import showSwal from "/src/mixins/showSwal.js";

export default {
  name: "Profile",
  components: {
    SoftButton,
    SoftAvatar,
    SoftModelInput,
    ValidationError,
  },
  mixins: [formMixin],
  data() {
    const passChange = {
      password: "",
      password_confirmation: "",
    };
    const profileChange = {
      name: "",
      email: "",
      profile_image: "",
    };
    return {
      passChange,
      profileChange,
      loading: false,
      loading2: false,
      img,
      file: null,
    };
  },
  computed: {
    profile() {
      return this.$store.getters["profile/profile"];
    },
    preview() {
      if (this.file) return URL.createObjectURL(this.file);
      else if (this.profile.profile_image) return this.profile.profile_image;
      else return require("/src/assets/img/placeholder.jpg");
    },
    pic() {
      if (this.profile.profile_image) return this.profile.profile_image;
      else return require("/src/assets/img/d320-icon.jpg");
    },
  },
  async created() {
    try {
      await this.$store.dispatch("profile/getProfile");
      this.profileChange = { ...this.profile };
    } catch (error) {
      try {
        await this.$store.dispatch("auth/logout");
      } finally {
        this.$router.push("/login");
      }
    }
  },
  methods: {
    async handlePassChange() {
      if (this.profile.id <= 3) {
        showSwal.methods.showSwal({
          type: "error",
          message: "You cannot change data of default users!",
          width: 450,
        });
        return;
      }
      this.resetApiValidation();
      this.loading = true;

      // check if password is empty
      if (this.passChange.password === "") {
        showSwal.methods.showSwal({
          type: "error",
          message: "Bitte gib ein Passwort an!",
          width: 450,
        });
        this.loading = false;
        return;
      }

      // check if passwords match
      if (this.passChange.password !== this.passChange.password_confirmation) {
        showSwal.methods.showSwal({
          type: "error",
          message: "Die Passwörter stimmen nicht überein!",
          width: 450,
        });
        this.loading = false;
        return;
      }

      try {
        const response = await this.$store.dispatch("profile/changePassword", this.passChange.password);
        showSwal.methods.showSwal({
          type: "success",
          message: response.data,
          width: 500,
        });
        this.passChange.password = "";
        this.passChange.password_confirmation = "";
        this.loading = false;
        // logout user
        await this.$store.dispatch("auth/logout");
        await this.$router.push("/login");
      } catch (error) {
        showSwal.methods.showSwal({
          type: "error",
          message: error.response.data.data,
          width: 450,
        });
        this.loading = false;
      }
    },
  },
};
</script>
<style>
img {
  object-fit: cover;
}
</style>
